<template>
  <div class="become-a-professional-modal">
    <div class="become-a-professional">
      <div
        data-w-id="d38d056a-5848-cc53-bba8-b735b37b89f2"
        class="link-block-5 w-inline-block"
      >
        <img
          src="@/assets/timeslot-images/cancel.svg"
          loading="lazy"
          alt=""
          @click="cancel"
        />
      </div>
      <img
        src="@/assets/timeslot-images/animation_500_l3vkfkxp.gif"
        loading="lazy"
        width="170"
        alt=""
      />
      <div class="text-block-copy">Successful</div>
      <div class="text-block-3-copy">You are now a professional!<br /></div>
      <router-link
        to="/professional-dashboard"
        data-w-id="d38d056a-5848-cc53-bba8-b735b37b8a0a"
        @click="proceed"
        class="button-15 w-button"
        >Proceed</router-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ProfessionalSuccessModal",
  props: {
    cancel: Function,
    proceed: Function
  }
};
</script>

<style scoped></style>
